import './form.scss';

import Pristine from 'pristinejs';
import axios from 'axios';
import { createElementFromHTML, getOffset, smoothScrollTo } from './../../utilities/js/helper';

import { WidgetInstance } from 'friendly-challenge';

class FormHandler {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-form',
            validateOnlyAttr: 'data-form-validateonly',
            scrollOffset: 50
        };

        this.settings = Object.assign({}, defaults, options);
        this.$form = $element;
        this.$header = document.querySelector('[data-siteheader="root"]');
        this.$loadingSpinner = createElementFromHTML(window.OPTIONS.loader);

        this.validationConfig = {
            classTo: 'is--pristine',
            errorClass: 'has--error',
            successClass: 'has--success',
            errorTextParent: 'form-field__error',
            errorTextTag: 'div',
            errorTextClass: ''
        };

        this.pristine = null;
        this.validateOnly = this.$form.hasAttribute(this.settings.validateOnlyAttr);

        this.initialize();
    }

    initialize () {
        this.initForm();
    }

    initForm () {
        const $form = this.$form.querySelector('form');
        const $button = $form.querySelector('button[type="submit"]');
        this.pristine = new Pristine($form, this.validationConfig, false);
        const $fields = $form.querySelectorAll('.is--pristine input, .is--pristine textarea, .is--pristine select');

        this.initCaptcha($form);

        $form.addEventListener('submit', (e) => {
            e.preventDefault();

            const valid = this.pristine.validate($fields);

            if (valid === true) {
                this.submitForm($form);
            } else {
                this.scrollToFirstError($form);
            }
        });

        $button.classList.add('is--disabled');
        $form.addEventListener('change', (e) => {
            const valid = this.pristine.validate($fields, true);

            const $target = e.target;
            if (!$target.type === 'file') {
                const validTarget = this.pristine.validate($target, false); // eslint-disable-line
            }

            if ($target.getAttribute('data-pristine-validate') === 'live') {
                const validTarget = this.pristine.validate($target, false); // eslint-disable-line
            }

            /*
            const $uploader = $form.querySelector('[data-uploader="root"]');
            if ($uploader && $uploader.classList.contains('has--error')) {
                valid = false;
            }
            */

            if (valid === true) {
                $button.classList.remove('is--disabled');
            } else {
                $button.classList.add('is--disabled');
            }
        });

        $form.addEventListener('keyup', (e) => {
            const $target = e.target;

            if ($target.getAttribute('data-pristine-validate') === 'live') {
                const validTarget = this.pristine.validate($target, false); // eslint-disable-line
            }
        });
    }

    initCaptcha ($form) {
        const $friendlyCaptcha = $form.querySelector('.frc-captcha');
        if ($friendlyCaptcha) {
            const widget = new WidgetInstance($friendlyCaptcha, {  // eslint-disable-line
                skipStyleInjection: true
            });
        }
    }

    scrollToFirstError ($form) {
        const headerHeight = parseInt(this.$header.offsetHeight);
        const $firstError = $form.querySelectorAll('.has--error')[0];
        if ($firstError) {
            const errorScrollPosition = getOffset($firstError);
            smoothScrollTo(0, errorScrollPosition.top - headerHeight - this.settings.scrollOffset);
        }
    }

    async submitForm ($form) {
        const $button = $form.querySelector('button[type="submit"]');
        const formMethod = $form.getAttribute('method');
        const formAction = $form.getAttribute('action');
        const formData = new FormData($form);
        const formHSVContestPage = document.querySelector('[data-contest-hsv="form"]');
        const formHSVContestErrorMessage = document.querySelector('[data-contest-hsv="technical-error"]');

        if ($button !== null) {
            $button.appendChild(this.$loadingSpinner);
            $button.setAttribute('disabled', true);
        }

        if (!this.validateOnly) {
            /* If HSV-Contest Page Form */
            if (formHSVContestPage) {
                axios({
                    method: formMethod,
                    url: formAction,
                    data: formData
                })
                    .then((result) => {
                        if (result && result.data.success && result.data.content) {
                            formHSVContestErrorMessage.classList.remove('is--visible');
                            const $result = createElementFromHTML(result.data.content);
                            formHSVContestPage.innerHTML = '';
                            formHSVContestPage.appendChild($result);
                            document.querySelector('[data-contest-hsv="form-headline"]').remove();
                            formHSVContestPage.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center'
                            });
                        } else {
                            formHSVContestErrorMessage.classList.add('is--visible');
                            formHSVContestErrorMessage.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center'
                            });
                        }
                    })
                    .catch((error) => {
                        throw Error(error);
                    });
            } else {
                axios({
                    method: formMethod,
                    url: formAction,
                    data: formData
                })
                    .then((result) => {
                        if (result && result.data) {
                            const $result = createElementFromHTML(result.data);
                            const $resultContent = $result.innerHTML;

                            let $resultContainer = null;

                            if ($resultContent) {
                                const headerHeight = parseInt(this.$header.offsetHeight);

                                // @TODO kaho: refactor after mvp
                                if ($result.querySelector('form')) {
                                    this.$form.innerHTML = $resultContent;
                                    this.initForm();

                                    this.scrollToFirstError($form);

                                    $resultContainer = this.$form;

                                    const $message = $result.querySelector('[data-form="message"]');
                                    if ($message) {
                                        let successScrollPosition = 0;

                                        if (this.$form.getAttribute('data-formtarget')) {
                                            const targetId = this.$form.getAttribute('data-formtarget');
                                            const $target = document.getElementById(targetId);

                                            if ($target) {
                                                successScrollPosition = getOffset($target);

                                                const $firstChild = $target.firstElementChild;
                                                if ($firstChild) {
                                                    $target.insertBefore($message, $firstChild);

                                                    const $closeButton = $message.querySelector('[data-form="closemessage"]');

                                                    if ($closeButton) {
                                                        $closeButton.addEventListener('click', (e) => {
                                                            $message.parentNode.removeChild($message);

                                                            successScrollPosition = getOffset($target);
                                                            smoothScrollTo(0, successScrollPosition.top - headerHeight - this.settings.scrollOffset);
                                                            e.preventDefault();
                                                        });
                                                    }
                                                }
                                            }
                                        }

                                        smoothScrollTo(0, successScrollPosition.top - headerHeight - this.settings.scrollOffset);
                                    }
                                } else {
                                    let successScrollPosition = 0;

                                    if (this.$form.getAttribute('data-formtarget')) {
                                        const targetId = this.$form.getAttribute('data-formtarget');
                                        const $target = document.getElementById(targetId);
                                        if ($target) {
                                            successScrollPosition = getOffset($target);
                                        }

                                        $target.innerHTML = $resultContent;
                                        $resultContainer = this.$target;
                                    } else {
                                        this.$form.innerHTML = $resultContent;
                                        successScrollPosition = getOffset(this.$form);
                                        $resultContainer = this.$form;
                                    }

                                    smoothScrollTo(0, successScrollPosition.top - headerHeight - this.settings.scrollOffset);
                                }
                            }

                            const contentUpdateEvent = new CustomEvent('content.loaded', {
                                view: window,
                                bubbles: true,
                                cancelable: false,
                                detail: {
                                    $context: $resultContainer
                                }
                            });
                            window.dispatchEvent(contentUpdateEvent);

                            window.checkInview(window.eventScroller);
                        }
                    })
                    .catch((error) => {
                        throw Error(error);
                    });
            }
        }
    }
}

export { FormHandler };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$form = $context.querySelectorAll('[data-form="root"]');
        for (let i = 0; i < $$form.length; i++) {
            const $form = $$form[i];

            const formAPI = new FormHandler($form);
            $form.API = formAPI;
        }
    }
});
